import { AsyncForm } from "src/components/common/forms/AsyncForm.tsx";
import {
	SitePartRevisionPriceConfiguratorFormApi,
	SitePartRevisionPriceConfiguratorFormApi_FormInitData,
} from "src/api/generated/erp/parts/sitePart/api/sitePartRevisionPriceConfiguratorFormApi.ts";
import { FormCommonProps } from "src/components/common/forms/types.ts";
import { FormConfiguratorLuaEditor } from "src/components/views/erp/configurator/scripting/FormConfiguratorLuaEditor.tsx";
import { SitePartRevisionUnrestrictedEditingWarning } from "src/components/views/erp/parts/siteParts/SitePartRevisionUnrestrictedEditingWarning.tsx";
import { VerticalBox } from "src/components/common/box/VerticalBox";
import i18n from "i18next";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface SitePartRevisionPriceConfiguratorFormProps extends FormCommonProps<void> {
	partRevisionId: number;
}

interface FormValues {
	configurationPricingScript: string;
}

export const SitePartRevisionPriceConfiguratorForm = ({
	partRevisionId,
	onCompleted,
	onFormEdited,
}: SitePartRevisionPriceConfiguratorFormProps) => {
	return (
		<AsyncForm<SitePartRevisionPriceConfiguratorFormApi_FormInitData, FormValues, void>
			fetch={() => SitePartRevisionPriceConfiguratorFormApi.getFormInitData({ partRevisionId })}
			getDefaultValues={({ partRevision }) => partRevision}
			getUseFormProps={({ partRevision }) => ({
				disabled: partRevision.partRevisionState === "RELEASED" && !partRevision.unrestrictedEditingCascaded,
			})}
			render={({ control, data: { partRevision } }) => (
				<VerticalBox sx={{ flex: 1 }}>
					<SitePartRevisionUnrestrictedEditingWarning revision={partRevision} />
					<FormConfiguratorLuaEditor
						control={control}
						name={"configurationPricingScript"}
						productFamilyVersionId={partRevision.configurationProductFamilyVersionId}
						catalogPartRevisionId={partRevision.catalogPartRevisionId}
						label={i18n.t("pricing_function")}
						sx={{
							margin: 1,
							marginTop: 2,
						}}
					/>
				</VerticalBox>
			)}
			submit={async ({ configurationPricingScript }) => {
				await SitePartRevisionPriceConfiguratorFormApi.submit({
					partRevisionId,
					configurationPricingScript,
				});
			}}
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			agentContext={{
				key: defineAgentUiContextKey("erp.parts.sitePartRevisionPriceConfigurator.form"),
				data: { partRevisionId },
			}}
		/>
	);
};
